module.exports = __webpack_public_path__ + "media/offers/paper-1-f412c68c.png";